module.exports = __webpack_public_path__ + "img/icon_1_17.888e0b00.png";